import { apiRequest } from "./apiClient";
import type {
  AddKbQuestionAnswerRequest,
  FetchKbQuestionsParams,
  KbQuestionDetailResponse,
  KbQuestionToggleActiveResponse,
  KbQuestionsResponse
} from "../types/kbQuestion";

export const fetchKbQuestions = async (
  params: FetchKbQuestionsParams
): Promise<KbQuestionsResponse> => {
  const sp = new URLSearchParams();
  sp.set("page", String(params.page));
  sp.set("page_size", String(params.page_size));
  sp.set("sort_by", params.sort_by);
  sp.set("sort_dir", params.sort_dir);

  if (params.search?.trim()) {
    sp.set("search", params.search.trim());
  }
  if (params.status) {
    sp.set("status", params.status);
  }

  const res = await apiRequest(`/kb/questions?${sp.toString()}`);
  return (await res.json()) as KbQuestionsResponse;
};

export const fetchKbQuestionDetail = async (
  questionId: string
): Promise<KbQuestionDetailResponse> => {
  const res = await apiRequest(`/kb/questions/${encodeURIComponent(questionId)}`);
  return (await res.json()) as KbQuestionDetailResponse;
};

export const toggleKbQuestionActive = async (
  questionId: string
): Promise<KbQuestionToggleActiveResponse> => {
  const res = await apiRequest(`/kb/questions/${encodeURIComponent(questionId)}/toggle-active`, {
    method: "PUT",
  });
  return (await res.json()) as KbQuestionToggleActiveResponse;
};

export const addKbQuestionAnswer = async (
  questionId: string,
  payload: AddKbQuestionAnswerRequest
): Promise<void> => {
  await apiRequest(`/kb/questions/${encodeURIComponent(questionId)}/answers`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });
};
